export const portalIt: Record<string, string> = {
  'portal': 'Portale',
  'back_to_help': "Torna all'Aiuto",

  // Help Categories
  'first_fitting': 'Prima Prova',
  'undergarments_foundation': 'Biancheria Intima e Base',
  'transport_care': 'Trasporto e Cura',
  'wedding_day_preparation': 'Preparazione Giorno del Matrimonio',
  'alterations_process': 'Processo di Modifiche',
  'general_faq': 'FAQ Generali',

  // Help page
  'help_tips': 'Aiuto e Consigli',
  'help_description': 'Trova risposte alle domande comuni e ottieni consigli utili per il tuo viaggio nuziale.',
  'search_articles': 'Cerca articoli...',
  'all_categories': 'Tutte le Categorie',
  'article_found': 'articolo trovato',
  'articles_found': 'articoli trovati',
  'no_articles_found': 'Nessun articolo trovato',
  'adjust_search': 'Prova ad aggiustare i termini di ricerca o il filtro categoria.',
  'no_articles_available': 'Nessun articolo è attualmente disponibile.',
  'read_full_article': "Leggi l'articolo completo",

  // Wishlist
  'my_wishlist': 'La Mia Lista Desideri',
  'wishlist_coming_soon': 'Prossimamente',
  'wishlist_description': "Raccogli e organizza l'ispirazione per il tuo matrimonio da sogno in una bella galleria",
  'loading_wishlist': 'Caricamento della tua lista desideri...',
  'dresses': 'Abiti',
  'veils': 'Veli',
  'shoes': 'Scarpe',
  'jewelry': 'Gioielli',
  'lookbook': 'Catalogo',
  'dress': 'Abito',
  'veil': 'Velo',
  'add_item': 'Aggiungi Elemento',
  'pinterest': 'Pinterest',
  'in_store': 'In Negozio',
  'add_to_wishlist': 'Aggiungi alla Lista Desideri',
  'title_optional': 'Titolo (Opzionale)',
  'title_placeholder': 'es., Elegante Abito A-Line',
  'image_url_upload': 'URL Immagine o Carica',
  'image_url_placeholder': 'Incolla link Pinterest o carica foto',
  'add_to_wishlist_btn': 'Aggiungi alla Lista Desideri',
  'share_your_wishlist': 'Condividi la Tua Lista Desideri',
  'share_description': 'Crea un link condivisibile alla tua lista desideri che amici e famiglia possono vedere.',
  'create_share_link': 'Crea Link di Condivisione',
  'no_items_yet': 'Nessun elemento {category} ancora',
  'no_items_all': 'Nessun elemento ancora',
  'wishlist_empty_description': 'Inizia a costruire la tua collezione matrimoniale da sogno aggiungendo foto e link di ispirazione.',
  'add_first_item': 'Aggiungi il Tuo Primo Elemento',
  'wishlist_preview_notice': "Questa è un'anteprima della prossima funzione Lista Desideri e Catalogo. Tutte le funzionalità inclusa galleria masonry, filtraggio per categoria, condivisione e aggiunte staff in tempo reale saranno abilitate presto!",

  // Wishlist Categories
  'wishlist_dress': 'Abito',
  'wishlist_veil': 'Velo',
  'wishlist_shoes': 'Scarpe',
  'wishlist_jewelry': 'Gioielli',
  'wishlist_other': 'Altro',

  // Wishlist Sources
  'source_instore': 'In Negozio',
  'source_pinterest': 'Pinterest',
  'source_lookbook': 'Catalogo',
  'source_upload': 'Carica',

  // Loyalty
  'loyalty_referrals': 'Fedeltà e Referenze',
  'earn_rewards_referring': 'Guadagna ricompense riferendo amiche alla loro esperienza abito da sogno',
  'loyalty_progress': 'Progresso Fedeltà',
  'refer_friends': 'Riferisci {target} amiche per sbloccare la tua ricompensa',
  'progress': 'Progresso',
  'referrals': 'referenze',
  'reward_veil_cleaning': 'Ricompensa: Servizio pulizia velo gratuito',
  'your_referral_code': 'Il Tuo Codice Referenza',
  'share_code_friends': 'Condividi questo codice con le amiche per sconti esclusivi',
  'tap_reveal_code': 'Tocca per rivelare il codice',
  'preview_mode': '(Modalità anteprima)',
  'code_hide_15s': 'Il codice si nasconderà in 15 secondi',
  'reveal_code': 'Rivela Codice',
  'terms_conditions': 'Termini e Condizioni',
  'accept_terms': 'Ho letto e accetto i termini e le condizioni (Modalità anteprima)',
  'recent_referrals': 'Referenze Recenti',
  'track_referrals': 'Traccia le tue referenze di successo',
  'no_referrals_yet': 'Nessuna referenza ancora',
  'start_sharing': 'Inizia a condividere per guadagnare ricompense!',
  'loyalty_preview_notice': "Questa è un'anteprima della prossima funzione Fedeltà e Referenze. Tutte le funzionalità saranno abilitate presto!",
  'loading_rewards': 'Caricamento delle tue ricompense...',
  'full_screen_inspiration': 'Ispirazione a schermo intero',
  'inspiration': 'ispirazione',
  'coming_soon_badge': 'Prossimamente',
  'get_discount_appointment': 'Ottieni il 10% di sconto sul tuo appuntamento nuziale!',
  'use_referral_code': 'Usa il mio codice referenza: {code}',
  'share_cancelled': 'Condivisione annullata o fallita',
  'copy_referral_fallback': 'Usa il mio codice referenza: {code} su {url}',
  'referral_valid_new_customers': 'I codici referenza sono validi solo per nuovi clienti.',
  'friends_book_deposit': 'Le amiche devono prenotare e pagare un acconto per qualificarsi come referenza di successo.',
  'email_one_use_only': 'Ogni indirizzo email può usare un codice referenza solo una volta.',
  'rewards_after_booking': 'Le ricompense sono guadagnate dopo che le prenotazioni amiche di successo sono confermate.',
  'points_expire_inactivity': 'I punti fedeltà scadono dopo 12 mesi di inattività.',
  'rewards_no_cash_exchange': 'Le ricompense non possono essere scambiate per valore in contanti.',
  'terms_subject_change': 'Termini soggetti a modifica con preavviso.',

  // Portal payments
  'portal.payments.payButton': 'Paga Saldo',
  'portal.payments.amountLabel': 'Importo',
  'portal.payments.balanceRemaining': 'Saldo Rimanente',
  'portal.payments.successToast': 'Pagamento Riuscito',
  'portal.payments.errorOverLimit': 'Importo superiore al saldo rimanente',
  'portal.requests.title': 'Richieste di Pagamento',
  'portal.requests.payNow': 'Paga Ora',
  'portal.requests.status.pending': 'In Attesa',
  'portal.requests.status.sent': 'Inviato',
  'portal.requests.status.paid': 'Pagato',
  'portal.requests.status.cancelled': 'Annullato',
  'portal.requests.status.partiallyPaid': 'Parzialmente Pagato',
  'portal.requests.payRemaining': 'Paga Rimanente',
  'portal.requests.noneOpen': 'Nessuna richiesta di pagamento in sospeso al momento.',
  'portal.requests.completeFirst': 'Completa prima il pagamento #{number}',
  'portal.progress.amountPaid': 'Importo Pagato',
  'portal.progress.progress': 'Progresso',
  'portal.progress.remaining': 'Rimanente',

  // Modale pagamento portale
  'portal.pay.modal.title': 'Completa pagamento',
  'portal.pay.context.order': 'Ordine',
  'portal.pay.context.invoice': 'Fattura',
  'portal.pay.context.request': 'Richiesta di pagamento',
  'portal.pay.outstanding': 'Residuo',
  'portal.pay.minimum': 'Minimo',
  'portal.pay.submit': 'Continua al pagamento',
  'portal.pay.success': 'Pagamento completato',
  'portal.pay.amount.label': 'Importo pagamento',
  'portal.pay.amount.minError': "L'importo deve essere almeno",
  'portal.pay.amount.maxError': 'e non superiore a',
  'portal.pay.amount.payLabel': 'Paga €{amount}',
  'portal.pay.quick.min': 'Minimo',
  'portal.pay.quick.half': '50%',
  'portal.pay.quick.remaining': 'Residuo',
  'portal.pay.quick.minAria': "Imposta importo al minimo: €{amount}",
  'portal.pay.quick.halfAria': "Imposta importo al 50%: €{amount}",
  'portal.pay.quick.remainingAria': "Imposta importo al residuo: €{amount}",
  'portal.pay.loading.form': 'Caricamento modulo di pagamento...',

  // Errori pagamento portale
  'portal.pay.error.title': 'Errore pagamento',
  'portal.pay.error.refresh': 'Ricarica la pagina per riprovare',
  'portal.pay.error.configMissing': 'Configurazione pagamento mancante',
  'portal.pay.error.configInvalid': 'Configurazione pagamento non valida',
  'portal.pay.error.initFailed': 'Impossibile inizializzare il sistema di pagamento',
  'portal.pay.error.loadFailed': 'Impossibile caricare il sistema di pagamento',
  'portal.pay.error.unavailable': 'Sistema di pagamento non disponibile',
  'portal.pay.error.notReady': 'Il sistema di pagamento non è pronto. Attendi e riprova.',
  'portal.pay.error.formNotReady': 'Il modulo di pagamento non è pronto. Attendi il caricamento completo.',
  'portal.pay.error.formLoadFailed': 'Impossibile caricare il modulo di pagamento. Ricarica e riprova.',
  'portal.pay.error.cardDeclined': 'La carta è stata rifiutata. Prova un metodo di pagamento diverso.',
  'portal.pay.error.invalidNumber': 'Controlla il numero della carta e riprova.',
  'portal.pay.error.invalidExpiry': 'Controlla la data di scadenza della carta e riprova.',
  'portal.pay.error.invalidCvc': 'Controlla il codice di sicurezza della carta e riprova.',
  'portal.pay.error.failed': 'Pagamento non riuscito',
  'portal.pay.error.generic': 'Errore pagamento',

  // Messaggi inizializzazione pagamento
  'portal.pay.intent.setupErrorTitle': 'Errore configurazione pagamento',
  'portal.pay.intent.unavailable': 'La configurazione del pagamento non è disponibile al momento. Riprova tra poco.',
  'portal.pay.intent.unavailableShort': 'Il servizio pagamenti non è disponibile al momento. Riprova a breve.',
  'portal.pay.intent.timeout': 'La configurazione del pagamento sta richiedendo più tempo del previsto. Riprova.',
  'portal.pay.intent.network': 'Problema di rete. Controlla la connessione e riprova.',
  'portal.pay.intent.concurrent': "Un altro pagamento è stato elaborato durante la preparazione di questo pagamento. Ricarica la pagina e riprova.",
  'portal.pay.intent.alreadyPaid': 'Questa richiesta di pagamento è già stata saldata completamente.',
  'portal.pay.intent.invalidResponse': 'Risposta pagamento non valida dal server',
  'portal.pay.intent.configIncomplete': 'Configurazione pagamento incompleta',
  'portal.pay.intent.setupFailed': 'Configurazione pagamento non riuscita. Riprova.',
  'portal.pay.intent.setupTimeout': 'Timeout durante la configurazione del pagamento. Riprova.',
  'portal.pay.intent.networkError': 'Errore di rete. Controlla la connessione e riprova.',

  // Pulsanti e testo assistivo pagamento
  'portal.pay.button.preparing': 'Preparazione...',
  'portal.pay.button.retrying': 'Nuovo tentativo...',
  'portal.pay.button.tryAgain': 'Riprova',
  'portal.pay.button.processing': 'Elaborazione...',
  'portal.pay.button.loading': 'Caricamento modulo di pagamento...',
  'portal.pay.sr.processing': 'Pagamento in elaborazione, attendere',
  'portal.pay.sr.loading': 'Modulo di pagamento in caricamento, attendere',
  'portal.pay.sr.disabledReason': "Pulsante disabilitato perché l'importo è fuori dall'intervallo valido",
  'portal.offline.checkConnectionAlert': 'Controlla la connessione internet e riprova',
  'portal.offline.title': 'Sei attualmente offline',
  'portal.offline.description1': 'Non preoccuparti: alcune funzionalità sono disponibili anche offline.',
  'portal.offline.description2': 'Il tuo percorso bridal continua quando ti riconnetti!',
  'portal.offline.goToPortal': 'Vai al Portale',
  'portal.offline.checkConnection': 'Controlla connessione',
  'portal.offline.comingSoon': 'Funzionalità offline in arrivo:',
  'portal.offline.featureAppointments': 'Visualizza appuntamenti in cache',
  'portal.offline.featurePhotos': 'Sfoglia foto salvate',
  'portal.offline.featureHelp': "Leggi articoli di aiuto",
};
